import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { Select, Tag } from 'antd'
import {
  red,
  volcano,
  gold,
  yellow,
  lime,
  green,
  cyan,
  blue,
  geekblue,
  purple,
  magenta,
  grey,
} from '@ant-design/colors'
import { useTranslation } from 'react-i18next'
import CentredLoader from 'components/CentredLoader'
import { ComplementaryOptionType } from 'types/index'

const GET_COMPLEMENTARY_OPTIONS = gql`
  query getComplementaryOptions {
    complementaryOptions {
      id
      title
    }
  }
`

interface Props {
  field: any
  form: any
  defaultValues: [number]
}

function getColor(id: number) {
  const colors = [
    red,
    gold,
    green,
    cyan,
    purple,
    volcano,
    yellow,
    geekblue,
    lime,
    blue,
    magenta,
    grey,
  ]

  return colors[id % colors.length][3]
}

const ComplementaryOptions = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { loading, data } = useQuery(GET_COMPLEMENTARY_OPTIONS)

  if (loading) return <CentredLoader />

  const { complementaryOptions } = data

  const { Option } = Select

  const tagRender = ({
    label,
    value,
    onClose,
  }: {
    label: any
    value: any
    onClose: any
  }) => {
    const id = complementaryOptions.findIndex(
      (obj: ComplementaryOptionType) => obj.id == value
    )
    return (
      <Tag
        color={getColor(id)}
        closable
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    )
  }

  return (
    <React.Fragment>
      <label>{t('complementaryOption.label')}</label>
      <Select
        mode="multiple"
        showArrow
        tagRender={tagRender}
        defaultValue={props.defaultValues || []}
        placeholder={t('complementaryOption.placeholder')}
        style={{ width: '100%' }}
        onChange={e => {
          props.form.setFieldValue(props.field.name, e)
        }}
      >
        {complementaryOptions.map((item: ComplementaryOptionType) => {
          return (
            <Option
              key={item.id}
              value={item.id}
              disabled={props.field.value.length === 8}
            >
              {item.title}
            </Option>
          )
        })}
      </Select>
    </React.Fragment>
  )
}

export default ComplementaryOptions
